import { render, staticRenderFns } from "./slot-widget.vue?vue&type=template&id=77a5c12e&scoped=true&"
import script from "./slot-widget.vue?vue&type=script&lang=js&"
export * from "./slot-widget.vue?vue&type=script&lang=js&"
import style0 from "./slot-widget.vue?vue&type=style&index=0&id=77a5c12e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5c12e",
  null
  
)

export default component.exports